import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import OnboardingTipsModal from "@/components/OnboardingTipsModal";

export default function AppLayout() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    // Close mobile drawer on every route change.
    useEffect(() => { setMobileOpen(false); }, [location.pathname]);

    // Expose a global toggle so the Topbar (in any page) can open the mobile drawer.
    useEffect(() => {
        window.__akmToggleSidebar = () => setMobileOpen((v) => !v);
        return () => { delete window.__akmToggleSidebar; };
    }, []);

    return (
        <div className="flex h-screen overflow-hidden bg-background text-foreground" data-testid="app-shell">
            {/* Desktop + tablet (≥lg): persistent sidebar */}
            <div className="hidden lg:flex" data-testid="app-sidebar">
                <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
            </div>

            {/* Mobile/tablet (<lg): off-canvas drawer */}
            {mobileOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40 bg-black/40 lg:hidden"
                        onClick={() => setMobileOpen(false)}
                        aria-hidden
                    />
                    <div className="fixed inset-y-0 left-0 z-50 lg:hidden" data-testid="mobile-sidebar">
                        <Sidebar collapsed={false} onToggle={() => setMobileOpen(false)} mobile />
                    </div>
                </>
            )}

            <main className="flex h-full min-w-0 flex-1 flex-col overflow-hidden" data-testid="content-shell">
                <ImpersonationBanner />
                <Outlet />
                <OnboardingTipsModal />
            </main>
        </div>
    );
}
